// Select all elements with the class '.product__variants__item'
var variantItems = document.querySelectorAll('.product__variants__item');

// Add a click event listener to each variant item
variantItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      console.log('this one', e.target);
        var variant = {
            id: this.getAttribute('data-id'), // Assuming the variant ID is stored in a data attribute
            title: this.getAttribute('data-title'), // Similarly for title, adjust if necessary
            inventory_quantity: this.getAttribute('data-quantity'),
            inventory_policy: this.getAttribute('data-policy')
        };

        // Dispatching the event on the body element
        document.body.dispatchEvent(new CustomEvent('variantChange', {
            detail: {
                variant: variant
            },
            bubbles: true,
            cancelable: true
        }));
      console.log('clicked variant')
    //  removeUrlParams();
      
    });
});
// Listen for the 'variantChange' event on the body element
document.body.addEventListener('variantChange', function(e) {
    var variant = e.detail.variant;
    console.log('Variant clicked:', variant);
        
});

document.addEventListener('DOMContentLoaded', (event) => {
    const widthElements = document.querySelectorAll('.product__variants__width');
    const sizeElements = document.querySelectorAll('.product__variants__item');
    const productBtnTextElement = document.querySelector('.product__btn-text');
    const preBox = document.querySelector('.preorderbox');
    var addButton = document.querySelector('.product__btn-text');
    var qtyShow = document.querySelector('.data-qty-info');
    var sizeQty = document.querySelector('.size-qty');
    var submitButton = document.querySelector('.product-form__submit');
    var buttonWrapper = document.querySelector('.product-form__buttons');
    const sizeLabel = document.querySelector('legend.form__label[data-type="size"]');
    var variantId = document.querySelector('.variant_id_input');
    var productHandle = addButton.getAttribute("data-product-handle");
    var isWalletProduct = productHandle && productHandle.includes('wallet');
    
    // Check if product has size variants
    var hasSizeVariants = sizeElements.length > 1;
    var isProductWithoutSizes = isWalletProduct || !hasSizeVariants;

    let lastSelectedSize = document.querySelector('.product__variants__item.current')?.dataset.group;
    
    // Function to handle clicks when no size is selected
    function handleNoSizeClick(e) {
        // Only show size required message if no size is currently selected
        const currentSizeElement = document.querySelector('.product__variants__item.current');
        if (!currentSizeElement && sizeLabel) {
            sizeLabel.classList.add('size-required');
            const titleEl = sizeLabel.querySelector('.form__title');
            if (titleEl) {
                titleEl.textContent = 'Select a size';
            }
        }
    }
    
    function urlParms() {
      const queryParams = new URLSearchParams(window.location.search);
      const variantId = queryParams.get('variant');
      console.log(variantId, 'url variant id');
      if (!variantId) {
          console.log('No variant ID present in the URL.');
          return;
      }  
      document.querySelectorAll('.product__variants__item.current').forEach((element) => {
          element.classList.remove('current');
      });
  
      const variantElement = document.querySelector(`li[data-id="${variantId}"]`);
      if (variantElement) {
          variantElement.classList.add('current');
      }
    }
    /*
    function removeUrlParams() {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.delete('variant'); // Remove the variant parameter
      // Check if there are any parameters left
      const newQueryString = queryParams.toString();
      const newUrl = newQueryString ? window.location.pathname + '?' + newQueryString : window.location.pathname;
      
      // Update the URL without reloading the page
      history.pushState(null, '', newUrl);
    } */


function highlightVariant() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const variantUrlId = urlSearchParams.get('variant');
  console.log('Variant URL ID:', variantUrlId);
  if (!variantUrlId) {
    console.log('No variant ID provided in URL.');
    return; // Exit if no variant ID is provided
  }

  // Find all variant items on the page
  const variantItems = document.querySelectorAll('.product__variants__item');
  
  // Initially remove 'current' class only from the matching variant ID item
  let targetDataGroup = null;
  variantItems.forEach(item => {
    if (item.dataset.id === variantUrlId) {
      console.log(`Removing 'current' class from item with dataset.id: ${item.dataset.id}`);
      item.classList.remove('current');
      targetDataGroup = item.dataset.group; // Capture the data-group of the matching item
    }
  });

  // Check if targetDataGroup is found; if not, exit the function
  if (!targetDataGroup) {
    console.log('No matching data group found.');
    return;
  }
  
  console.log(`Target data group found: ${targetDataGroup}`);

  // Re-iterate over the items to add 'current' class to a different item with the same data-group
  let newDataId = null;
  for (let item of variantItems) {
    if (item.dataset.group === targetDataGroup && item.dataset.id !== variantUrlId) {
      item.classList.add('current');
      newDataId = item.dataset.id; // Use the data-id of this new matching item
      console.log(`'current' class added to a different item with new data ID: ${newDataId}`);
      break; // Exit the loop after finding the first eligible item
    }
  }

  // Proceed if a new variant ID was identified and it's different from the initial one
  if (newDataId) {
    console.log(newDataId, 'new data id')
      document.querySelectorAll('.product-form__buttons [data-cart-add], .variant_id_input').forEach(element => {
      if (element.tagName === 'INPUT') {
        element.value = newDataId; // Update the hidden input value
      } else {
        element.setAttribute('data-cart-add', newDataId); // Update the data-cart-add attribute
      }
    });

    // Update the 'variant' URL parameter with the new variant ID, preserving other parameters
    urlSearchParams.set('variant', newDataId);
    const newUrl = window.location.pathname + '?' + urlSearchParams.toString();
    window.history.pushState({ path: newUrl }, '', newUrl); // Update the browser URL without reloading the page
    console.log('Browser URL updated.');
  } else {
    console.log('No eligible new variant found to update.');
  }
}


    function updatePreOrderStatus() {
        const currentSizeElement = document.querySelector('.product__variants__item.current');
        console.log(currentSizeElement, 'currentSize landing');

        if (currentSizeElement) {
            const inventoryPolicy = currentSizeElement.getAttribute('data-policy');
            const inventoryQuantity = parseInt(currentSizeElement.getAttribute('data-quantity'), 10);
            var currentVariant = currentSizeElement.dataset.id;
            submitButton.setAttribute('data-cart-add', currentVariant);
            addButton.setAttribute('data-cart-add', currentVariant);
            variantId.value = currentVariant;
            console.log(currentVariant,'currentVariant inner');

            // Update URL with current variant ID
            const urlSearchParams = new URLSearchParams(window.location.search);
            urlSearchParams.set('variant', currentVariant);
            const newUrl = window.location.pathname + '?' + urlSearchParams.toString();
            window.history.pushState({ path: newUrl }, '', newUrl);

            submitButton.classList.remove('product__preorder', 'product__out-stock');
            submitButton.disabled = false;
            addButton.disabled = false;

            // Get button label texts from data attributes
            const addToCartText = addButton.getAttribute('data-add-to-cart-text');
            const preorderText = addButton.getAttribute('data-preorder-text');
            const soldOutText = 'Sold Out'; // optionally: addButton.getAttribute('data-sold-out-text') if you add it in Liquid


            if (inventoryPolicy === 'continue' && inventoryQuantity <= 0) {
                preBox.style.display = 'flex';
                addButton.innerHTML = preorderText;
                qtyShow.innerHTML = inventoryQuantity;
             	sizeQty.style.display = 'none';
                submitButton.disabled = false;
                addButton.disabled = false;
                addButton.classList.remove('no-size');
                submitButton.classList.remove('no-size');
                buttonWrapper.classList.remove('fake-button');
            } else {
                preBox.style.display = 'none';
                addButton.innerHTML = addToCartText;
                qtyShow.innerHTML = inventoryQuantity;
                if (inventoryQuantity <= 0) {
                  // Sold out but no preorder allowed
                  submitButton.classList.add('product__out-stock');
                  submitButton.disabled = true;
                  addButton.disabled = true;
                  addButton.textContent = soldOutText;
              }
            } // else ends

          if ( inventoryQuantity <= 0 || inventoryQuantity >= 10 ){
             	sizeQty.style.display = 'none';
             }
              else {
                sizeQty.style.display = 'flex';
              } // size else ends

        } else {
            // No size selected
            if (!isProductWithoutSizes) {
                // For products with size variants, disable button and show "Select a size"
                submitButton.disabled = true;
                addButton.disabled = true;
                addButton.textContent = 'Select a size';
                addButton.classList.add('no-size');
                submitButton.classList.add('no-size');
                buttonWrapper.classList.add('fake-button');
                
                // Remove any existing click listeners to prevent duplicates
                buttonWrapper.removeEventListener('click', handleNoSizeClick);
                buttonWrapper.addEventListener('click', handleNoSizeClick);
                
                // Clear any variant from URL when no size is selected
                const urlSearchParams = new URLSearchParams(window.location.search);
                urlSearchParams.delete('variant');
                const newUrl = window.location.pathname + (urlSearchParams.toString() ? '?' + urlSearchParams.toString() : '');
                window.history.pushState({ path: newUrl }, '', newUrl);
            } else {
                // For products without size variants (wallets, etc.), enable button and show appropriate text
                submitButton.disabled = false;
                addButton.disabled = false;
                const addToCartText = addButton.getAttribute('data-add-to-cart-text');
                addButton.textContent = addToCartText || 'Add To Cart';
            }
            
            preBox.style.display = 'none';
            sizeQty.style.display = 'none';
        }
    }

    function filterSizes(selectedWidth, hasWidths = true) {
        // If no width is provided or invalid, and product has widths, default to Standard
        if (hasWidths && (!selectedWidth || (selectedWidth !== 'Wide' && selectedWidth !== 'Standard'))) {
            console.warn('Invalid or missing width, defaulting to Standard');
            selectedWidth = 'Standard';
            // Try to find and select Standard width element
            const standardWidthElement = document.querySelector('.product__variants__width[data-width="Standard"]');
            if (standardWidthElement) {
                widthElements.forEach(w => w.classList.remove('current'));
                standardWidthElement.classList.add('current');
            }
        }

        // If product doesn't have widths, show all sizes
        if (!hasWidths) {
            sizeElements.forEach(function(sizeElement) {
                sizeElement.style.display = 'flex';
            });
            return;
        }

        let foundMatchingSize = false;

        sizeElements.forEach(function(sizeElement) {
            const sizeWidth = sizeElement.dataset.width;
            const sizeValue = sizeElement.dataset.group; // Assuming size is stored in data-group

            // For products with widths, only show variants with matching width
            // For products without widths, show all variants (sizeWidth will be undefined)
            const shouldShow = !hasWidths || (sizeWidth === selectedWidth);
            console.log('Size element:', sizeElement, 'Width:', sizeWidth, 'Selected:', selectedWidth, 'Should show:', shouldShow);
            if (shouldShow) {
                sizeElement.style.display = 'flex';
                // Check if this element matches the last selected size
                if (sizeValue === lastSelectedSize) {
                    sizeElement.classList.add('current');
                    updatePreOrderStatus();
                    foundMatchingSize = true;
                }
            } else {
                sizeElement.style.display = 'none';
                sizeElement.classList.remove('current');
            }
        });

        // If no matching size was found but we have a lastSelectedSize, try to find first available size for this width
        if (!foundMatchingSize && lastSelectedSize) {
            let firstSizeElement = document.querySelector(`.product__variants__item[data-width="${selectedWidth}"]`);
            if (firstSizeElement) {
                firstSizeElement.classList.add('current');
                lastSelectedSize = firstSizeElement.dataset.group;
                console.log(lastSelectedSize, 'last selected firstSize');
                updatePreOrderStatus();
            }
        }
        
        // Fallback: if no sizes are visible, show the first size for the selected width
        const visibleSizes = Array.from(sizeElements).filter(el => el.style.display !== 'none');
        if (visibleSizes.length === 0 && hasWidths) {
            console.warn('No sizes visible, showing first available size for width:', selectedWidth);
            let firstSizeElement = document.querySelector(`.product__variants__item[data-width="${selectedWidth}"]`);
            if (firstSizeElement) {
                firstSizeElement.style.display = 'flex';
                firstSizeElement.classList.add('current');
                lastSelectedSize = firstSizeElement.dataset.group;
                updatePreOrderStatus();
            }
        }
    }

    sizeElements.forEach(function(sizeElement) {
        sizeElement.addEventListener('click', function() {
            sizeElements.forEach(el => el.classList.remove('current'));
            this.classList.add('current');
            lastSelectedSize = this.dataset.group;
            console.log(lastSelectedSize, 'lastselected');
            
            // Skip size-related classes and logic for products without sizes
            if (!isProductWithoutSizes) {
                addButton.classList.remove('no-size');
                submitButton.classList.remove('no-size');
                buttonWrapper.classList.remove('fake-button');
                
                // Remove the click listener since a size is now selected
                buttonWrapper.removeEventListener('click', handleNoSizeClick);
                
                // Reset size label when a size is selected
                if (sizeLabel) {
                    sizeLabel.classList.remove('size-required');
                    const titleEl = sizeLabel.querySelector('.form__title');
                    if (titleEl) {
                        titleEl.textContent = 'Size';
                    }
                }
            }

            updatePreOrderStatus();
        });
    });

    widthElements.forEach(function(widthElement) {
        widthElement.addEventListener('click', function() {
          const selectedWidth = this.dataset.width;
          // Normalize "Wide(ee)" or "Wide (EE)" variations to "Wide" for consistency
          let normalizedWidth = selectedWidth;
          if (selectedWidth === 'Standard') {
            normalizedWidth = 'Standard';
            localStorage.setItem('selectedWidth', 'Standard');
          } else if (selectedWidth === 'Wide' || selectedWidth === 'Wide(ee)' || selectedWidth === 'Wide (EE)') {
            normalizedWidth = 'Wide';
            localStorage.setItem('selectedWidth', 'Wide');
          }
          filterSizes(normalizedWidth, hasWidthElements);
        })
    });

    // Initial setup - handle both products with and without widths
    const hasWidthElements = widthElements.length > 0;

    if (hasWidthElements) {
        // Check if there's a saved width preference in localStorage (prioritize this)
        const savedWidth = localStorage.getItem('selectedWidth');
        let initialWidth = 'Standard'; // Default to Standard
        
        console.log('Initial setup - savedWidth from localStorage:', savedWidth);
        
        // First, try to use saved width from localStorage if it exists and is valid
        let targetWidthElement = null;
        
        if (savedWidth === 'Standard' || savedWidth === 'Wide') {
            // Check if this width actually exists on the page (try exact match first)
            targetWidthElement = document.querySelector(`.product__variants__width[data-width="${savedWidth}"]`);
            
            if (targetWidthElement) {
                initialWidth = savedWidth;
                console.log('Found saved width element with exact match:', savedWidth);
            } else {
                // If saved width doesn't exist on this product, check for normalized variations
                if (savedWidth === 'Wide') {
                    // Try to find Wide with variations
                    const wideVariations = ['Wide', 'Wide(ee)', 'Wide (EE)'];
                    for (let wideVar of wideVariations) {
                        const wideElement = document.querySelector(`.product__variants__width[data-width="${wideVar}"]`);
                        if (wideElement) {
                            initialWidth = 'Wide';
                            targetWidthElement = wideElement;
                            console.log('Found saved width element with variation:', wideVar);
                            break;
                        }
                    }
                } else if (savedWidth === 'Standard') {
                    // For Standard, try exact match only (should always be 'Standard')
                    targetWidthElement = document.querySelector(`.product__variants__width[data-width="Standard"]`);
                    if (targetWidthElement) {
                        initialWidth = 'Standard';
                        console.log('Found Standard width element');
                    }
                }
            }
            
            if (!targetWidthElement) {
                console.log('Saved width not found on this product, will use default or existing selection');
            }
        }
        
        // If no valid saved width found, check if a width element is already selected (has 'current' class)
        if (!targetWidthElement) {
            const currentWidthElement = document.querySelector('.product__variants__width.current');
            if (currentWidthElement) {
                const currentWidth = currentWidthElement.dataset.width;
                // Normalize the current width
                if (currentWidth === 'Standard') {
                    initialWidth = 'Standard';
                } else if (currentWidth === 'Wide' || currentWidth === 'Wide(ee)' || currentWidth === 'Wide (EE)') {
                    initialWidth = 'Wide';
                }
                targetWidthElement = currentWidthElement;
                console.log('Using existing current width element:', currentWidth);
            }
        }
        
        // If still no target element, find one using the initialWidth value
        if (!targetWidthElement) {
            // Try exact match first, then try normalized variations
            targetWidthElement = document.querySelector(`.product__variants__width[data-width="${initialWidth}"]`);
            
            // If not found and we're looking for Wide, try variations
            if (!targetWidthElement && initialWidth === 'Wide') {
                const wideVariations = ['Wide', 'Wide(ee)', 'Wide (EE)'];
                for (let wideVar of wideVariations) {
                    targetWidthElement = document.querySelector(`.product__variants__width[data-width="${wideVar}"]`);
                    if (targetWidthElement) {
                        break;
                    }
                }
            }
        }
        
        // Select the target width element
        if (targetWidthElement) {
            // Remove 'current' class from all width elements
            widthElements.forEach(w => w.classList.remove('current'));
            // Add 'current' class to target width element
            targetWidthElement.classList.add('current');
            console.log('Selected width element:', targetWidthElement.dataset.width, 'initialWidth:', initialWidth);
        } else {
            // If target width element not found, try to find any width element and use its value
            const firstWidthElement = widthElements[0];
            if (firstWidthElement) {
                const firstWidth = firstWidthElement.dataset.width;
                // Normalize the first width
                if (firstWidth === 'Standard') {
                    initialWidth = 'Standard';
                } else if (firstWidth === 'Wide' || firstWidth === 'Wide(ee)' || firstWidth === 'Wide (EE)') {
                    initialWidth = 'Wide';
                }
                widthElements.forEach(w => w.classList.remove('current'));
                firstWidthElement.classList.add('current');
                console.log('Using first available width element:', firstWidth);
            }
        }
        
        // Products with widths: show sizes for the initial width (saved preference or Standard)
        filterSizes(initialWidth, hasWidthElements);
    } else {
        // Products without widths: show all sizes initially (no selection)
        sizeElements.forEach(sizeElement => {
            sizeElement.style.display = 'flex';
        });
    }

    // No size selected initially - set button appropriately based on product type
    updatePreOrderStatus();

    // Handle URL variant selection on page load
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariantId = urlParams.get('variant');
    if (urlVariantId) {
        const urlVariantElement = document.querySelector(`[data-id="${urlVariantId}"]`);
        if (urlVariantElement) {
            // Remove current selection
            document.querySelectorAll('.product__variants__item.current').forEach(el => el.classList.remove('current'));

            // If product has widths, make sure the correct width is selected
            if (hasWidthElements) {
                const variantWidth = urlVariantElement.dataset.width;
                if (variantWidth) {
                    // Normalize width value
                    let normalizedWidth = variantWidth;
                    if (variantWidth === 'Standard') {
                        normalizedWidth = 'Standard';
                    } else if (variantWidth === 'Wide' || variantWidth === 'Wide(ee)' || variantWidth === 'Wide (EE)') {
                        normalizedWidth = 'Wide';
                    }
                    
                    // Save width preference to localStorage if it's Standard or Wide
                    if (normalizedWidth === 'Standard' || normalizedWidth === 'Wide') {
                        localStorage.setItem('selectedWidth', normalizedWidth);
                    }
                    
                    // Find the appropriate width selector - try both exact match and normalized match
                    let widthSelector = document.querySelector(`.product__variants__width[data-width="${variantWidth}"]`);
                    if (!widthSelector && normalizedWidth !== variantWidth) {
                        widthSelector = document.querySelector(`.product__variants__width[data-width="${normalizedWidth}"]`);
                    }
                    
                    if (widthSelector) {
                        // Update width selection visuals
                        document.querySelectorAll('.product__variants__width').forEach(w => w.classList.remove('current'));
                        widthSelector.classList.add('current');
                        // Filter sizes for this width using the filterSizes function
                        filterSizes(normalizedWidth, hasWidthElements);
                    } else {
                        // If width selector not found, use filterSizes with the normalized width
                        // filterSizes will handle finding and selecting the appropriate width
                        filterSizes(normalizedWidth, hasWidthElements);
                    }
                } else {
                    // If variant doesn't have width, default to Standard
                    filterSizes('Standard', hasWidthElements);
                }
            }

            // Select the variant from URL
            urlVariantElement.classList.add('current');
            lastSelectedSize = urlVariantElement.dataset.group;

            // Reset size label when a size is selected from URL (skip for products without sizes)
            if (!isProductWithoutSizes && sizeLabel) {
                sizeLabel.classList.remove('size-required');
                const titleEl = sizeLabel.querySelector('.form__title');
                if (titleEl) {
                    titleEl.textContent = 'Size';
                }
                
                // Remove the click listener since a size is now selected
                buttonWrapper.removeEventListener('click', handleNoSizeClick);
            }

            updatePreOrderStatus();
        }
    }
    
    // Select all list items within the 'product-width-wrapper' class
    var widthItems = document.querySelectorAll('.product-width-wrapper .product__variants__width');
    
    // Add a click event listener to each list item
    widthItems.forEach(function(item) {
        item.addEventListener('click', function() {
            // Remove 'current' class from all items
            widthItems.forEach(function(innerItem) {
                innerItem.classList.remove('current');
            });
    
            // Add 'current' class to the clicked item
            this.classList.add('current');
            
            // Save selected width to localStorage if it's Standard or Wide
            // Normalize "Wide(ee)" or "Wide (EE)" variations to "Wide" for consistency
            const selectedWidth = this.dataset.width;
            let normalizedWidth = selectedWidth;
            if (selectedWidth === 'Standard') {
                normalizedWidth = 'Standard';
                localStorage.setItem('selectedWidth', 'Standard');
            } else if (selectedWidth === 'Wide' || selectedWidth === 'Wide(ee)' || selectedWidth === 'Wide (EE)') {
                normalizedWidth = 'Wide';
                localStorage.setItem('selectedWidth', 'Wide');
            }
            
            // Filter sizes based on selected width
            if (hasWidthElements) {
                filterSizes(normalizedWidth, hasWidthElements);
            }
        });
    });
});
